import React, { useMemo } from "react";
import { ChatMessage } from "../../types/chat";
import MessageItem from "../MessageItem";
import TypingIndicator from "../TypingIndicator";
import WelcomeMessage from "../WelcomeMessage";
import DefinitionModal from "../modals/DefinitionModal";

interface ChatContainerProps {
  messages: ChatMessage[];
  conversationRef: React.RefObject<HTMLDivElement>;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({
  messages,
  conversationRef,
}) => {
  // Extract definition message and regular messages
  const { definitionMessage, regularMessages } = useMemo(() => {
    const lastMessage = messages[messages.length - 1];
    const filteredMessages = messages.filter(
      (msg) => msg.endpoint_result !== "definition"
    );

    if (lastMessage && lastMessage.endpoint_result === "definition") {
      return {
        definitionMessage: lastMessage,
        regularMessages: filteredMessages,
      };
    }

    return {
      definitionMessage: null,
      regularMessages: messages,
    };
  }, [messages]);

  return (
    <>
      <div
        ref={conversationRef}
        className="flex-1 flex flex-col overflow-y-auto p-2 sm:p-3 lg:p-4 gap-2 sm:gap-3 lg:gap-4 min-h-0 w-full"
      >
        <div className="mt-auto">
          {regularMessages.length === 0 ? (
            <WelcomeMessage />
          ) : (
            <>
              {regularMessages.map((message, index) => {
                const isLastMessage = index === regularMessages.length - 1;
                return (
                  <MessageItem
                    key={message.id}
                    id={message.id}
                    messageId={message.messageId}
                    text={message.text}
                    dateTime={message.dateTime}
                    origin={message.origin}
                    messageType={message.messageType}
                    nodeUuid={message.nodeUuid}
                    options={message.options}
                    audio={message.audio}
                    media={message.media}
                    preFetchedMediaBlob={message.preFetchedMediaBlob}
                    preFetchedAudioBlob={message.preFetchedAudioBlob}
                    preFetchedMediaUrl={message.preFetchedMediaUrl}
                    isFlagged={message.isFlagged}
                    loadMedia={true}
                    isLastMessage={isLastMessage}
                  />
                );
              })}
              <TypingIndicator />
            </>
          )}
        </div>
      </div>

      {/* Definition Modal */}
      <DefinitionModal message={definitionMessage} />
    </>
  );
};
